var _circle, _rect, _rect2, _line, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSponsoredPerks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 30.5,
    width: 42,
    height: 11,
    fill: "#103B5D",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 41.5,
    width: 38,
    height: 20,
    fill: "#103B5D",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.5,
    y1: 30,
    x2: 39.5,
    y2: 61,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7828 19.2406C41.5943 21.558 40.2657 27.3791 40 30C43.1885 29.5862 49.074 28.8215 51.1598 25.4479C52.7004 22.9561 51.787 20.839 51.0668 19.7174C50.1611 18.3067 47.9713 16.9232 44.7828 19.2406Z",
    stroke: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2172 19.2406C37.4057 21.558 38.7343 27.3791 39 30C35.8115 29.5862 29.926 28.8215 27.8402 25.4479C26.2996 22.9561 27.213 20.839 27.9332 19.7174C28.8389 18.3067 31.0287 16.9232 34.2172 19.2406Z",
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsoredPerks);
export default __webpack_public_path__ + "static/media/Sponsored_perks.1feda3ced4dc042a40cef2d1f7ddd345.svg";
export { ForwardRef as ReactComponent };